import React, { useState } from "react";

export default function SearchSendReports(props) {
  const {
    handleSearchSubmit, getFilesReady, date, category,
  } = props;

  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value === "") {
      getFilesReady(date, "", "DSC", category);
      handleSearchSubmit(e, value, true);
    }
  };
  return (
    <input
      onChange={(e) => handleSearch(e)}
      onKeyDown={(e) => handleSearchSubmit(e, searchValue, false)}
      className="sendReportsInputSearch"
      type="text"
      name=""
      id=""
      placeholder="Search by WO"
      value={searchValue}
    />
  );
}
